/* eslint-disable react/jsx-key */
import RBAC from 'hoc/RBAC';
import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';

const RBAC_TABS = ({
  tabs,
  selectedTab,
  onTabChange,
  className = 'mb-3',
  tabsCount = [],
}) => {
  return (
    <Nav className={`custom-tabs w-100 ${className}`} tabs>
      {tabs.map((tab, i) => {
        return (
          <RBAC allowedRoles={tab?.allowedRoles} key={tab?.link}>
            <NavItem key={tab?.link}>
              <NavLink
                className="border-0 mb-0 bg-transparent"
                active={selectedTab === tab?.link}
                onClick={() => {
                  onTabChange(tab?.link);
                }}
              >
                {tab?.link} {tabsCount.length > 0 && `(${tabsCount[i]})`}
              </NavLink>
            </NavItem>
          </RBAC>
        );
      })}
    </Nav>
  );
};

export default RBAC_TABS;
